import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "../lib/api";

export default function WhatsAppButton() {
  const [num, setNum] = useState("");
  useEffect(() => {
    const load = () => api.get("/settings").then(r => setNum(r.data?.site?.whatsapp_number || "")).catch(() => {});
    load();
    window.addEventListener("lel-settings-updated", load);
    return () => window.removeEventListener("lel-settings-updated", load);
  }, []);
  if (!num) return null;
  const clean = num.replace(/[^\d]/g, "");
  const msg = encodeURIComponent("Bonjour Larmes en Lumière, je souhaite en savoir plus.");
  return (
    <a href={`https://wa.me/${clean}?text=${msg}`} target="_blank" rel="noopener noreferrer"
       className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] grid place-items-center shadow-2xl hover:scale-110 transition-transform"
       data-testid="whatsapp-btn" aria-label="Contact WhatsApp">
      <MessageCircle className="text-white fill-white" size={26}/>
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
    </a>
  );
}
